export default "__VITE_ASSET__3b056cc3__"